module.exports = __webpack_public_path__ + "img/logo.b305fca5.png";